/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type OverviewFavoriteItem_item = {
    readonly serviceId: string | null;
    readonly firstPhotoWebPath: string | null;
    readonly localizedPdpUrl: string | null;
    readonly title: string | null;
    readonly seller: {
        readonly serviceId: string | null;
    } | null;
    readonly isContemporary: boolean | null;
    readonly isCustomizable: boolean | null;
    readonly isNewAndMadeToOrder: boolean | null;
    readonly classification: {
        readonly categories: ReadonlyArray<{
            readonly category: {
                readonly key: string | null;
                readonly browseUrl: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly pricing: {
        readonly amount: {
            readonly amount: number | null;
        } | null;
        readonly netPrice: {
            readonly amount: number | null;
        } | null;
        readonly salePrice: {
            readonly amount: number | null;
        } | null;
    } | null;
    readonly " $refType": "OverviewFavoriteItem_item";
};
export type OverviewFavoriteItem_item$data = OverviewFavoriteItem_item;
export type OverviewFavoriteItem_item$key = {
    readonly " $data"?: OverviewFavoriteItem_item$data;
    readonly " $fragmentRefs": FragmentRefs<"OverviewFavoriteItem_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v1 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "OverviewFavoriteItem_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstPhotoWebPath",
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "thumb"
        }
      ],
      "storageKey": "firstPhotoWebPath(size:\"thumb\")"
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "localizedPdpUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isContemporary",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isCustomizable",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isNewAndMadeToOrder",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "classification",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemClassification",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "categories",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemCategory",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "category",
              "storageKey": null,
              "args": null,
              "concreteType": "Category",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "key",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "browseUrl",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pricing",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPricing",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "amount",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": (v1/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "netPrice",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": (v1/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "salePrice",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": (v1/*: any*/)
        }
      ]
    }
  ]
};
})();
(node as any).hash = '0dc9ed0e8286fdad9b66b34d5c0bd88c';
export default node;
